if (!window.customElements.get("component-products-slider")) {

class ProductsSlider extends HTMLElement {

  constructor() {
    super();

    this.selectors = {
      swiper: "swiper-container",
      prevEl: ".custom-prev-button",
      nextEl: ".custom-next-button"
    }

    this.slider = this.querySelector(this.selectors.swiper);
    this.buttonPrev = this.querySelector(this.selectors.prevEl);
    this.buttonNext = this.querySelector(this.selectors.nextEl);
    this.initSlider();
    this.addListeners();
  }

  initSlider() {
    const isSimilarProducts = Boolean(this.closest(".similar-products"));

    const swiperParams = {
      slidesPerView: "auto",
      watchOverflow: true,
      slidesOffsetBefore: isSimilarProducts ? 20 : 0,
      slidesOffsetAfter: isSimilarProducts ? 20 : 0,
      breakpoints: {
        640: {
          slidesPerView: 2,
          slidesOffsetBefore: isSimilarProducts ? 20 : 0,
          slidesOffsetAfter: isSimilarProducts ? 20 : 0,
        },
        990: {
          slidesPerView: 4.38,
          slidesOffsetBefore: isSimilarProducts ? 40 : 0,
          slidesOffsetAfter: isSimilarProducts ? 40 : 0,
        },
        1600: {
          slidesPerView: 4.6,
          slidesOffsetBefore: isSimilarProducts ? 100 : 0,
          slidesOffsetAfter: isSimilarProducts ? 100 : 0,
        },
        2048: {
          slidesPerView: 4.6,
          slidesOffsetBefore: isSimilarProducts ? 200 : 0,
          slidesOffsetAfter: isSimilarProducts ? 200 : 0,
        },
      },
      navigation: {
        nextEl: this.buttonNext,
        prevEl: this.buttonPrev
      },
      on: {
        init() {
        }
      },
    };

    Object.assign(this.slider, swiperParams);

    this.slider.initialize();

  }

  addListeners() {
    document.addEventListener('shopify:section:reorder', () => this.initSlider());
    document.addEventListener('shopify:section:load',() => this.initSlider());
  }
}

  window.customElements.define("component-products-slider", ProductsSlider);
}
